
// components
import Spinner from "../common/spinner";
import RecentlyViewedProducts from "../common/recentlyViewedProducts";

const RelatedProducts = ({ data }) => {
  return data ? (
    <div className="py-1">
     
      <RecentlyViewedProducts />
    </div>
  ) : (
    <Spinner message={"Bringing the related products..."} />
  );
};

export default RelatedProducts;
